import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { AUTH_STORAGE_KEYS } from 'app/core/auth/auth-storage';
import { AuthService } from 'app/core/auth/auth.service';
import { BooleanInput } from '@angular/cdk/coercion';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    exportAs: 'user',
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, MatIconModule, NgClass, MatDividerModule, RouterModule],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    userName: string = '';
    userEmail: string = '';
    userAvatar: string = '';
    userID: string = '';
    userType: string = '';
    userState: string = '';
    clientID: string = '';

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _authService: AuthService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this.userName = this._authService.userName;
        this.userEmail = this._authService.userEmail;
        this.userAvatar = this._authService.userAvatar;
        this.userID = this._authService.userId;
        this.userType = this._authService.userType;
        this.clientID = this._authService.userClientId;

        const surnames = this._authService.userSurnames;
        if (surnames) {
            if (surnames.indexOf(' ') !== -1) {
                this.userName = this.userName + ' ' + surnames.slice(0, surnames.indexOf(' '));
            } else {
                this.userName = this.userName + ' ' + surnames;
            }
        }

        if (!localStorage.getItem(AUTH_STORAGE_KEYS.userStatus)) {
            localStorage.setItem(AUTH_STORAGE_KEYS.userStatus, 'online');
            this.userState = 'online';
        } else {
            this.userState = localStorage.getItem(AUTH_STORAGE_KEYS.userStatus);
        }
        if (!this.userAvatar || this.userAvatar === 'null') {
            this.showAvatar = false;
        }
    }

    loadProfile(): void {
        this._router.navigate(['/admin/colaboradores/' + this.userID + '/informacion']).then(() => {
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.userState) {
            localStorage.setItem(AUTH_STORAGE_KEYS.userStatus, 'online');
            this.userState = 'online';
        }

        localStorage.setItem(AUTH_STORAGE_KEYS.userStatus, status);
        this.userState = status;
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
